import React, { useState } from 'react';
import api from '../services/api';
import Box from '@mui/material/Box'; 

// (Giữ nguyên)
const MOI_QUAN_HE_OPTIONS = [
  { key: '1', value: '(1) Mẹ đẻ' },
  { key: '2', value: '(2) Bà ngoại ruột' },
  { key: '3', value: '(3) Anh, chị, em cùng mẹ đẻ' },
  { key: '4', value: '(4) Anh, chị, em cùng mẹ đẻ với mẹ đẻ' },
  { key: '5', value: '(5) Con ruột của chị/em gái mẹ đẻ' },
  { key: '6', value: '(6) Con của chị/em gái' },
];

// (CẬP NHẬT) Thêm "du_phong"
const STT_THAN_NHAN_OPTIONS = [
  { key: '1', value: 'Thân nhân 1' },
  { key: '2', value: 'Thân nhân 2' },
  { key: 'du_phong', value: 'STT 3, 4, 5... (Dự phòng)' }, // (MỚI)
];

// Component này quản lý việc thêm Liệt sĩ/Quan hệ
function AddLietSiQuanHe({ xaId, moiQuanHeList, setMoiQuanHeList, setError, clearError }) {
  
  const [searchTenLS, setSearchTenLS] = useState('');
  const [searchLSResult, setSearchLSResult] = useState([]);
  const [selectedLietSi, setSelectedLietSi] = useState(null);
  const [thonInfo, setThonInfo] = useState('');
  const [duplicateWarning, setDuplicateWarning] = useState('');
  
  const [newQuanHe, setNewQuanHe] = useState({
    loai_quan_he: '1',
    stt_than_nhan: '1' // Mặc định là STT 1
  });

  // (Giữ nguyên) Xử lý tìm kiếm liệt sĩ
  const handleSearchLietSi = async () => {
    clearError();
    if (searchTenLS.length < 3) { setSearchLSResult([]); return; }
    try {
      const res = await api.get(`/lietsi/search?ten=${searchTenLS}&xa_id=${xaId}`); 
      setSearchLSResult(res.data);
      setSelectedLietSi(null); 
      setDuplicateWarning('');
    } catch (err) { setError(err.response?.data?.message || 'Lỗi tìm kiếm liệt sĩ'); }
  };
  
  // (CẬP NHẬT - Yêu cầu 2) Xử lý thêm Mối quan hệ
  const handleAddLietSiQuanHe = async () => {
    let lietSiId = selectedLietSi?.id;
    clearError();
    setDuplicateWarning('');

    if (!searchTenLS) { setError('Vui lòng nhập tên liệt sĩ'); return; }
    
    // (Giữ nguyên) Logic tạo/tìm liệt sĩ
    if (!lietSiId) {
      try {
        const res = await api.post('/lietsi', { 
          ho_ten: searchTenLS, 
          thon_info: thonInfo,
          xa_id: xaId 
        });
        lietSiId = res.data.id;
      } catch (err) {
        if (err.response?.status === 409) { setDuplicateWarning(err.response.data.message); return; }
        setError(err.response?.data?.message || 'Lỗi tạo liệt sĩ mới'); return;
      }
    }
    
    // (*** CẬP NHẬT - YÊU CẦU 2 ***) Kiểm tra logic STT 1, 2 (Rule 2)
    // (Kiểm tra trên danh sách tạm thời ở frontend)
    const sttCount = moiQuanHeList.filter(mqh => 
        (mqh.liet_si_id === lietSiId) && 
        mqh.stt_than_nhan === newQuanHe.stt_than_nhan
    ).length;

    if (newQuanHe.stt_than_nhan === '1' && sttCount > 0) {
      setError(`Liệt sĩ này đã được thêm làm Thân nhân thứ 1 trong danh sách này.`);
      return;
    }
    
    if (newQuanHe.stt_than_nhan === '2') {
         if (sttCount > 0) {
             setError(`Liệt sĩ này đã được thêm làm Thân nhân thứ 2 trong danh sách này.`);
             return;
         }
         const stt1Exists = moiQuanHeList.some(mqh => 
             (mqh.liet_si_id === lietSiId) && 
             mqh.stt_than_nhan === '1'
         );
         if (!stt1Exists) {
             setError('Không thể thêm thân nhân thứ 2 khi chưa có thân nhân thứ 1.');
             return;
         }
    }
    
    // (*** CẬP NHẬT - YÊU CẦU 2 ***)
    // Nếu STT là "Dự phòng", Backend (createThanNhanByTinhAdmin) sẽ tự động
    // set trạng thái rà soát của thân nhân là "du_phong".

    // Thêm vào danh sách tạm thời (Frontend)
    const newEntry = {
        liet_si_id: lietSiId, 
        ho_ten: searchTenLS, 
        thon_info: thonInfo,
        loai_quan_he: newQuanHe.loai_quan_he,
        stt_than_nhan: newQuanHe.stt_than_nhan,
        loai_quan_he_text: MOI_QUAN_HE_OPTIONS.find(o => o.key === newQuanHe.loai_quan_he)?.value 
    };

    setMoiQuanHeList([...moiQuanHeList, newEntry]); 
    
    // Reset form thêm
    setSearchTenLS('');
    setSearchLSResult([]);
    setSelectedLietSi(null);
    setThonInfo('');
    setDuplicateWarning('');
  };
  
  // (Giữ nguyên) Xóa khỏi danh sách tạm
  const handleDeleteQuanHe = (index) => {
    setMoiQuanHeList(moiQuanHeList.filter((_, i) => i !== index));
    clearError();
  };
  
  // CSS nội tuyến (Giữ nguyên)
  const styles = {
    section: { marginBottom: '20px', border: '1px solid #eee', padding: '15px', borderRadius: '5px' },
    h4: { marginTop: '0', borderBottom: '1px solid #ccc', paddingBottom: '5px' },
    grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' },
    inputGroup: { display: 'flex', flexDirection: 'column' },
    button: { background: '#007bff', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', marginRight: '10px' },
    error: { color: 'red', fontWeight: 'bold' }
  };

  return (
    <Box>
      <div style={styles.section}>
        <h4 style={styles.h4}>Danh sách Liệt sĩ (Bắt buộc thêm ít nhất 1)</h4>
        
        {/* Bảng hiện thị mối quan hệ đã thêm */}
        <table style={{width: '100%', borderCollapse: 'collapse', marginBottom: '15px'}}>
              <thead><tr>
                <th style={{ padding: '8px', border: '1px solid #ccc' }}>Họ tên Liệt sĩ</th>
                <th style={{ padding: '8px', border: '1px solid #ccc' }}>Quan hệ</th>
                <th style={{ padding: '8px', border: '1px solid #ccc' }}>STT</th>
                <th style={{ padding: '8px', border: '1px solid #ccc' }}>Xóa</th>
              </tr></thead>
              <tbody>
                {moiQuanHeList.map((mq, index) => (
                  <tr key={index}>
                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>{mq.ho_ten} {mq.thon_info && `(${mq.thon_info})`}</td>
                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>{mq.loai_quan_he_text}</td>
                    {/* (CẬP NHẬT) Hiển thị tên STT mới */}
                    <td style={{ padding: '8px', border: '1px solid #ccc' }}>
                       {STT_THAN_NHAN_OPTIONS.find(o => o.key === mq.stt_than_nhan)?.value || mq.stt_than_nhan}
                    </td>
                    <td style={{ padding: '8px', border: '1px solid #ccc', textAlign: 'center' }}>
                      <button style={{background: 'red', color: 'white'}} onClick={() => handleDeleteQuanHe(index)}>Xóa</button>
                    </td>
                  </tr>
                ))}
                {moiQuanHeList.length === 0 && (
                   <tr><td colSpan="4" style={{textAlign: 'center', fontStyle: 'italic', color: 'gray', padding: '10px'}}>Chưa có liệt sĩ nào được thêm.</td></tr>
                )}
              </tbody>
            </table>

        {/* Form thêm Liệt sĩ mới */}
        <div style={{marginTop: '20px', background: '#f9f9f9', padding: '10px'}}>
            <h4 style={styles.h4}>Thêm Liệt sĩ</h4>
             <div style={styles.inputGroup}>
              <label>Tìm hoặc nhập tên Liệt sĩ:</label>
              <div style={{display: 'flex'}}>
                <input value={searchTenLS} onChange={(e) => setSearchTenLS(e.target.value)} placeholder="Nhập tên để tìm/thêm mới" style={{flex: 1}}/>
                <button type="button" onClick={handleSearchLietSi}>Tìm</button>
              </div>
            </div>
            
            {searchLSResult.length > 0 && (
              <div style={{border: '1px solid #ccc', padding: '5px', maxHeight: '100px', overflowY: 'auto'}}>
                <p>Chọn liệt sĩ đã có (Xã {xaId}):</p>
                {searchLSResult.map(ls => (
                  <div key={ls.id} onClick={() => {
                      setSelectedLietSi(ls); setSearchTenLS(ls.ho_ten); setThonInfo(ls.thon_info || ''); setSearchLSResult([]);
                    }} style={{padding: '5px', cursor: 'pointer', background: '#eee', marginBottom: '2Cập nhật 2px'}}>
                    {ls.ho_ten} {ls.thon_info && `(${ls.thon_info})`}
                  </div>
                ))}
              </div>
            )}
            {duplicateWarning && (
              <div style={{...styles.error, border: '1px solid red', padding: '10px', margin: '10px 0'}}>
                <p>{duplicateWarning}</p>
                <div style={styles.inputGroup}> <label>Thông tin Thôn/Xóm (để phân biệt):</label> <input value={thonInfo} onChange={(e) => setThonInfo(e.target.value)} /> </div>
              </div>
            )}
            
            <div style={{...styles.grid, gridTemplateColumns: '1fr 1fr', marginTop: '10px'}}>
              <div style={styles.inputGroup}>
                <label>Mối quan hệ:</label>
                <select name="loai_quan_he" value={newQuanHe.loai_quan_he} onChange={(e) => setNewQuanHe({...newQuanHe, loai_quan_he: e.target.value})}>
                  {MOI_QUAN_HE_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
                </select>
              </div>
              <div style={styles.inputGroup}>
                <label>Số thứ tự thân nhân:</label>
                {/* (CẬP NHẬT) Thêm option STT mới */}
                <select name="stt_than_nhan" value={newQuanHe.stt_than_nhan} onChange={(e) => setNewQuanHe({...newQuanHe, stt_than_nhan: e.target.value})}>
                  {STT_THAN_NHAN_OPTIONS.map(opt => <option key={opt.key} value={opt.key}>{opt.value}</option>)}
                </select>
              </div>
            </div>
            <button type="button" onClick={handleAddLietSiQuanHe} style={{marginTop: '10px', ...styles.button}}>+ Thêm vào danh sách</button>
          </div>
      </div>
    </Box>
  );
}

export default AddLietSiQuanHe;

